function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2E642C",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "user-2",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M21,19a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3,5,5,0,0,1,5-5h8A5,5,0,0,1,21,19Zm-9-7A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z",
    style: {
      fill: "rgb(46, 100, 44)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.a38e7bb4e455930f0cd8424ab3592c16.svg";
export { ForwardRef as ReactComponent };